import { Skeleton } from '@mantine/core';

import classes from './skeleton.module.css';

/** Inline placeholder for a value whose server response has not arrived yet. */
export const ValueSkeleton = ({ width = 48, label = 'Загружаем данные' }: { width?: number; label?: string }) => (
  <Skeleton
    className={classes.value}
    width={width}
    height="1em"
    radius="sm"
    display="inline-block"
    renderRoot={(props) => <span {...props} role="status" aria-label={label} aria-busy="true" />}
  />
);
